import classNames from "classnames";
import { ILabelValue } from "../Interfaces/CommonInterface";
import { StepperProps } from "./interface";
import "./Stepper.scss";
import { useSharedState } from "../../../components/services/WindowSizeService";


export function Stepper(props: StepperProps) {
    const { setSelectedStep, selectedStep, stepperData, stepperAlignmentClass } = props;
    const windowSize$ = useSharedState();
    return (
        <div className="stepper-root">
            <div className="bs-stepper">
                <div className="">
                    <div className={classNames('steps', stepperAlignmentClass)}>
                        <ul>
                            {stepperData && stepperData.map((item: ILabelValue, index: number) => {
                                return (
                                    <li className={classNames("step menu-link-hoverable",
                                        { "active displaying-class": selectedStep === index + 1 && (windowSize$ === "sm" || windowSize$ === "xs") },
                                        { "d-none": !(selectedStep === index + 1) && (windowSize$ === "sm" || windowSize$ === "xs") },
                                        { "active": selectedStep === index + 1 },
                                    )} key={index}>
                                        <a className="step-trigger" ><span className="step-indicator step-indicator-icon"></span><span className="d-sm-inline">{item?.label}</span></a>
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Stepper;